<template>
    <section class="contact" ref="contactSection">
      <div class="contact-content">
        <div class="contact-box" ref="contactBox">
          <h3>{{ $t('contact.title') }}</h3>
          <p>{{ $t('contact.description') }}</p>
          <div class="contact-links">
            <a href="mailto:miloszrolla.business@gmail.com" class="contact-link" ref="emailLink">
              <i class="fas fa-envelope"></i> miloszrolla.business@gmail.com
            </a>
            <a href="https://www.linkedin.com/in/miloszrolla/" target="_blank" class="contact-link" ref="linkedinLink">
              <i class="fab fa-linkedin"></i> LinkedIn
            </a>
          </div>
        </div>
      </div>
      <div class="background-element" ref="backgroundElement"></div>
    </section>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  
  gsap.registerPlugin(ScrollTrigger);
  
  const contactSection = ref(null);
  const sectionTitle = ref(null);
  const contactBox = ref(null);
  const backgroundElement = ref(null);
  const emailLink = ref(null);
  const linkedinLink = ref(null);
  
  onMounted(() => {
    // Animate section title
    gsap.from(sectionTitle.value, {
      y: 50,
      opacity: 0,
      duration: 1,
      scrollTrigger: {
        trigger: contactSection.value,
        start: 'top 80%',
      }
    });
  
    // Animate contact box
    gsap.from(contactBox.value, {
      y: 50,
      opacity: 0,
      duration: 1,
      delay: 0.3,
      scrollTrigger: {
        trigger: contactSection.value,
        start: 'top 80%',
      }
    });
  
    // Levitating animation for contact box
    gsap.to(contactBox.value, {
      y: '-30px',
      duration: 5.5,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    });
  
    // Rotate background element
    gsap.to(backgroundElement.value, {
      rotation: 360,
      duration: 20,
      repeat: -1,
      ease: 'linear'
    });
  
    // Animate contact links
    gsap.from([emailLink.value, linkedinLink.value], {
      x: -30,
      opacity: 0,
      duration: 0.5,
      stagger: 0.2,
      scrollTrigger: {
        trigger: contactBox.value,
        start: 'top 80%',
      }
    });
  });
  </script>
  
  <style scoped>
  .contact {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 20px;
    background-color: #0a0a0a;
    color: #ffffff;
    position: relative;
    overflow: hidden;
  }
  
  .section-title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    position: relative;
    z-index: 2;
  }
  
  .contact-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    position: relative;
    z-index: 2;
  }
  
  .contact-box {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
    border: 1px solid rgba(255, 255, 255, 0.18);
    max-width: 1000px;
    min-height: 400px;
  }
  
  .contact-box h3 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #ff3366;
  }
  
  .contact-box p {
    font-size: 1.5rem;
    margin-bottom: 2rem;
    color: #cccccc;
  }
  
  .contact-links {
    display: flex;
    flex-direction: column;
  }
  
  .contact-link {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    color: #ffffff;
    text-decoration: none;
    margin-bottom: 1rem;
    transition: color 0.3s ease;
  }
  
  .contact-link:hover {
    color: #ff3366;
  }
  
  .contact-link i {
    margin-right: 10px;
    font-size: 1.2rem;
  }
  
  .background-element {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 500px;
    background: linear-gradient(45deg, #ff3366, #ff6b99);
    opacity: 0.1;
    border-radius: 50%;
    filter: blur(100px);
    z-index: 1;
  }
  
  @media (max-width: 768px) {
    .contact-box {
      padding: 30px;
    }
  }
  </style>